
    import {computed, ComputedRef, defineComponent, reactive, watch} from 'vue'
    import {useStore} from "@/store";
    import reportMsgUt from "@/util/reportMsg";
    import utils from '@/util/index';
    import {useRoute, useRouter} from "vue-router";
    import { Popup } from 'scvant';

    interface State {
        point: ComputedRef<"N" | "Y">; // N 没有三种缺陷 Y 有三种缺陷
        isAccident: number; // 0不是事故车 1是事故车
        isFire: number; // 0不是事故车 1是事故车
        isWater: number; // 0不是事故车 1是事故车
        reportCode: string | null;
        channelType: string;
        logoUrl: string;
        protectTime: string;
        promiseMsg: string;
        reportMsg: object;
        templateCode: string;
        brandName: string;
        modelName: string;
        vin: string;
        reportGenDate: string;
        showProtect: boolean;
        isXNY: boolean;
        isSF: any;
        productName: string;
        accidentFlag: number;// 0 非事故车 1 非重大事故 2 重大事故车
        showPromiseDes: string;
        isHasPromise: boolean;
        rankDesc: any;
        scoreDesc: any;
        appearanceSum: any;
        interiorSum: any;
        rank: string | null;
        score: string | null;
        brandLogo: string;
        reportFreeCheckVersion: any;
    }

    export default defineComponent({
        name: "headTip",
        setup() {
            const {query} = useRoute();
            let state: State = reactive({
                point: "Y" as any,
                isAccident: 1,
                isFire: 1,
                isWater: 1,
                reportCode: '',
                channelType: `${query.channelType}` || '',
                logoUrl: '',
                protectTime: '90',
                promiseMsg: '享90天回购及重要部件赔付保障',
                reportMsg: {},
                templateCode: '',
                brandName: '',
                modelName: '',
                vin: '',
                reportGenDate: '',
                showProtect: false,
                isXNY: false,
                isSF: -1,
                productName: `${query.productName || ''}`,
                accidentFlag: 2,
                showPromiseDes: '',
                rankDesc: null,
                scoreDesc: null,
                appearanceSum: null,
                interiorSum: null,
                rank: null,
                score: null,
                brandLogo: '',
                reportFreeCheckVersion: null,
                isHasPromise: false
            })
            state.reportMsg = reportMsgUt;
            state.reportCode = `${query.reportCode}`;
            state.templateCode = `${query.templateCode}`;
            state.protectTime = state.channelType === 'jiaxuan' ? '100' : '90';
            // 获取路由器实例
            const router = useRouter()
            let store = useStore();
            let dataInfo: ComputedRef<{}> = computed<{}>(() => store.state.dataInfo);
            let isNormal: ComputedRef<{}> = computed<{}>(() => store.state.isNormal);
            let reportResultList: ComputedRef<{}> = computed<{}>(() => store.state.reportResultList);
            state.isSF = computed(() => {
                return store.state.isNormal
            });
            state.point = computed(() => {
                return store.state.isNormal ? 'N' : 'Y'
            })
            console.log('reportResultList:', reportResultList);
            // 享90天回购保障{{state.reportMsg.RpSRZ() ? '｜付费享1年３万公里保修' : ''}}
            // let promiseDes = `享${state.protectTime}天回购保障`;
            // if (state.reportMsg['Rp699']()) {
            //     promiseDes = `享${state.protectTime}天回购及重要部件赔付保障`;
            // } else if (state.reportMsg['RpHC']()) {
            //     promiseDes = `享${state.protectTime}天赔付保障`;
            // }
            // state.showPromiseDes = `查看《${promiseDes}说明》`;
            // state.promiseMsg = promiseDes + (state.reportMsg['RpSRZ']() ? '｜付费享1年3万公里保修' : '');
            watch(dataInfo, (data: any) => {
                const {
                        isAccident, 
                        isFire, 
                        isWater, 
                        reportConfigInfo, 
                        brandName, 
                        modelName, 
                        vin, 
                        reportDetectOrderVO, 
                        energyType,
                        productName,
                        accidentFlag, 
                        rankDesc, 
                        scoreDesc, 
                        appearanceSum, 
                        interiorSum, 
                        rank,
                        score,
                        brandLogo,
                        reportFreeCheckVersion
                    } = data;
                state.logoUrl = reportConfigInfo ? reportConfigInfo.logoUrl : '';
                state.isAccident = accidentFlag > -1 ?  accidentFlag : isAccident ;
                state.isFire = isFire
                state.isWater = isWater
                state.brandName = brandName
                state.modelName = modelName
                state.vin = vin;
                state.reportGenDate = reportDetectOrderVO.reportGenDate
                state.isXNY = energyType === 2 ? true : false;
                state.rankDesc = rankDesc;
                state.scoreDesc = scoreDesc;
                state.appearanceSum = appearanceSum;
                state.interiorSum = interiorSum;
                state.rank = rank;
                state.score = score;
                state.brandLogo = utils.replaceImageUrl(brandLogo);
                state.reportFreeCheckVersion = reportFreeCheckVersion || 0;
                state.isHasPromise = rank !== 'D';
                // console.log(productName);
                // console.log(accidentFlag);
                //第一版新版报告上线静态化中没有productName字段并且上线的是299相关报告，解析完为undefined,用事故排查检测
                if (!state.productName) {
                    state.productName = productName === undefined ? '收车检测' : (productName === null ? '' :productName); 
                }
                state.accidentFlag = accidentFlag;
            })
            function getHeadPromiseBgStyle(): object {
                let promiseStyle = {'head_promise_bg_299': true};
                return promiseStyle;
            }
            function getHeadResultBgStyle(): object  {
                let resultBgStyle = {};
                if (state.rank !== 'D') {
                    resultBgStyle = {'head_result_sf_bg': true};
                } else {
                    resultBgStyle = {'head_result_sf_bg_noguarantee': true,'result_bg_nosf': state.rank === 'D'};
                }
                return resultBgStyle;
            }
            function getAccidentDes(): string  {
                let accidentDes = '';
                if (state.accidentFlag === undefined) {//走旧的逻辑
                    accidentDes = !state.isAccident ? '非事故车' : '事故车';
                } else {//根据accidentFlag判断
                    if (state.accidentFlag  === 0) {
                        accidentDes = '非事故车';
                    }  else if (state.accidentFlag  === 1) {
                         accidentDes = '事故车';
                    }  else if (state.accidentFlag  === 2) {
                        accidentDes = '重大事故车';
                    }
                }
                return accidentDes;
            }
            function getWenLiPic() {
                let wenLiPic = null;
                if (state.reportMsg['Rp499']()) {
                    wenLiPic = require("../../../assets/tocV3/toCV3RectangleWenLiGray.png");
                }else if (state.reportMsg['Rp699']()) {
                    wenLiPic = require("../../../assets/tocV3/toCV3RectangleWenLiOrange.png");
                }
                return wenLiPic;
            }
            function getVectorIcon() {
                let vectorIcon = require("../../../assets/tocV4/headVector.png");
                return vectorIcon;
            }
            function getRightArrowIcon() {
                let arrowIcon = require("../../../assets/tocV4/headArrowRight.png");
                return arrowIcon;
            }
            function getPromiseMsgFont(): object  {
                let fontStyle = {};
                if (state.reportMsg['RpHC']()) {
                    fontStyle = {'head_promise_font_hc': true};
                } else if (state.reportMsg['Rp699']()) {
                    fontStyle = {'head_promise_font_699': true};
                } else if (state.reportMsg['Rp499']()) {
                    fontStyle = {'head_promise_font_499': true};
                } else {
                    fontStyle = {'head_promise_font_299': true};
                }
                return fontStyle;
            }
            //获取等级标签图标
            function getResBoxLevelIcon() {
                let levelIcon = null;
                if (state.rank === 'S') {
                    levelIcon = require("../../../assets/tocV4/S_299.png");
                } else if (state.rank === 'C'){
                    levelIcon = require("../../../assets/tocV4/C_299.png");
                } else if (state.rank === 'D'){
                    levelIcon = require("../../../assets/tocV4/D_299.png");
                }
                return levelIcon;
            }
            // 获取评分图标
            function getResBoxScoreIcon(index) {
                let levelIcon = null;
                if (state.score) {
                    levelIcon = require(`../../../assets/tocV4/score_${state.score && state.score[index]}.png`);
                }
                return levelIcon;
            }
            function getResJiStyleIcon() {
                let jiIcon = require("../../../assets/tocV4/ji_299.png");
                return jiIcon;
            }
            // function getResBoxItemTxtWrapStyle() {
            //     let txtWrapStyle = {'resBox_item_txt_wrap_299': true};
            //     return txtWrapStyle;
            // }
            return {
                state,
                router,
                dataInfo,
                isNormal,
                reportResultList,
                getAccidentDes,
                getWenLiPic,
                getHeadPromiseBgStyle,
                getHeadResultBgStyle,
                getVectorIcon,
                getRightArrowIcon,
                getResBoxLevelIcon,
                getResBoxScoreIcon,
                getResJiStyleIcon,
                getPromiseMsgFont,
            }
        },
        components: {
            [Popup.name]: Popup,
        },
        methods: {
            toExplain() {
                this.router.push({
                    path: '/tocSCJExplainFreeCheck',
                    query: {
                        channelType: this.state.channelType,
                        templateCode: this.state.templateCode,
                        reportFreeCheckVersion: this.state.reportFreeCheckVersion
                    }
                })
            },
            setShowProtect(){
                let lbParam = {
                    templateCode: this.state.templateCode
                }
                this.state.showProtect = !this.state.showProtect;
            }
        }
    })
